<script lang="ts">

    import {NavigationState} from "../models/NavigationState";
    import {NavigationStateStore, QuestionAnswerMeta} from "../services/Store";
    import {onDestroy} from "svelte";
    import {QuestionAnswerData} from "../models/QuestionAnswerData";
    import {startMedicalQuestionsProcess} from "../services/NavigationService";

    let eligibleImage = process.env.ImagesUrl + 'images/pending_24dp.png';
    let disabledImage = process.env.ImagesUrl + 'images/ellipse.png';
    let completedImage = process.env.ImagesUrl + 'images/check_circle_24dp.png';

    let navState = new NavigationState();
    const navStateUnsubscribe = NavigationStateStore.subscribe(value => navState = value);

    let questionMetadata: QuestionAnswerData;
    const questionAnswerDataUnsubscribe = QuestionAnswerMeta.subscribe(value => questionMetadata = value);

    $: if (navState) {
        mapFromNavigationState();
    }

    $: if (questionMetadata.questionsAnswered) {
        if (questionMetadata.complete == true && navState.contactMeCompleted != true) {
            if (navState.medicalQuestionsCompleted == false) {
                navState.medicalQuestionsCompleted = true;
            }
        }
    }

    onDestroy(navStateUnsubscribe);
    onDestroy(questionAnswerDataUnsubscribe);

    const navigationRequested = (requestedEntity: string) => {
        navState.resetNavigationState();
        navState.honestyStatement = false;
        switch(requestedEntity) {
            case 'honesty':
                navState.honestyStatement = true;
                break;
            case 'applicationReview':
                navState.applicationReview = true;

                break;
            case 'medical':
                if (!navState.medicalQuestionsRetrievalComplete) {
                    startMedicalQuestionsProcess();
                }
                navState.medicalQuestions = true;
                break;
            case 'hipaa':
                navState.hipaa = true;
                break;
            case 'identification':
                navState.identification = true;
                break;
            case 'readyToBeContacted':
                navState.readyToBeContacted = true;
                break;
            default:
                navState.resetNavigationState();
                break;
        }
        NavigationStateStore.set(navState);
    }

    function mapFromNavigationState() {
        if (navState.honestyStatementCompleted === true) {
            navState.honestyStatementEligible = false;
        }
        navState.readyToBeContactedEligible = !navState.contactMeCompleted;

    }

</script>

<div class="top-level-navigation">
    {#if navState.honestyStatementCompleted}
        <div>
            <a href="*" class="nav-block {navState.disableAll === true ? 'disabled-anchor' : ''}" on:click|preventDefault={() => navigationRequested('honesty')}>
                <img class="nav-image" alt="Honesty Statement Completed" src={completedImage}>
                <div class="nav-text-block">
                    Honesty Statement
                </div>
            </a>
        </div>
    {:else}
        <div>
            <a href="*" class="{(navState.honestyStatementEligible && !navState.disableAll) ? 'nav-block' : 'nav-block disabled-anchor'}" on:click|preventDefault={() => navigationRequested('honesty')}>
                {#if navState.honestyStatementEligible}
                    <img class="nav-image" src={eligibleImage} alt="Honesty Statement">
                {:else}
                    <img class="nav-image" src={disabledImage} alt="Honesty Statement not eligible">
                {/if}
                <div class="nav-text-block">
                    Honesty Statement
                </div>
            </a>
        </div>
    {/if}

    <div class="nav-dot">. .</div>

    {#if navState.applicationReviewCompleted}
        <div>
            <a href="*" class="nav-block {navState.disableAll === true ? 'disabled-anchor' : ''}" on:click|preventDefault={() => navigationRequested('applicationReview')}>
                <img class="completed-image" src={completedImage} alt="Application Review Completed">
                <div class="nav-text-block">
                    Review Information
                </div>
            </a>
        </div>
        {:else}
        <div>
            <a href="*" class="{(navState.applicationReviewEligible && !navState.disableAll) ? 'nav-block' : 'nav-block disabled-anchor'}" on:click|preventDefault={() => navigationRequested('applicationReview')}>
                {#if navState.applicationReviewEligible}
                    <img class="nav-image" alt="Application Review" src={eligibleImage}>
                {:else}
                    <img class="nav-image" alt="Application Review Not Eligible" src={disabledImage}>
                {/if}

                <div class="nav-text-block">
                    Review Information
                </div>
            </a>
        </div>
    {/if}

    <div class="nav-dot">. .</div>

    {#if navState.hipaaCompleted}
        <div>
            <a href="*" class="nav-block {navState.disableAll === true ? 'disabled-anchor' : ''}" on:click|preventDefault={() => navigationRequested('hipaa')}>
                <img class="completed-image" src={completedImage} alt="Hipaa Completed">
                <div class="nav-text-block">
                    eSign HIPAA
                </div>
            </a>
        </div>
        {:else}
        <div>
            <a href="*" class="{(navState.hipaaEligible && !navState.disableAll) ? 'nav-block' : 'nav-block disabled-anchor'}" on:click|preventDefault={() => navigationRequested('hipaa')}>
                {#if navState.hipaaEligible}
                    <img class="nav-image" alt="Hipaa" src={eligibleImage}>
                {:else}
                    <img class="nav-image" alt="Hipaa Not Eligible" src={disabledImage}>
                {/if}

                <div class="nav-text-block">
                    eSign HIPAA
                </div>
            </a>
        </div>
    {/if}

    <div class="nav-dot">. .</div>

    {#if navState.medicalQuestionsCompleted}
        <div>
            <a href="*" class="nav-block {navState.disableAll === true ? 'disabled-anchor' : ''}" on:click|preventDefault={() => navigationRequested('medical')}>
                <img class="completed-image" src={completedImage} alt="Medical Questions Completed">
                <div class="nav-text-block">
                    Complete Medical Questions
                </div>
            </a>
        </div>
    {:else}
        <div>
            <a href="*" class="{(navState.medicalQuestionsEligible && !navState.disableAll) ? 'nav-block' : 'nav-block disabled-anchor'}" on:click|preventDefault={() => navigationRequested('medical')}>
                {#if navState.medicalQuestionsEligible}
                    <img class="nav-image" alt="Medical Questions" src={eligibleImage}>
                {:else}
                    <img class="nav-image" alt="Medical Questions Not Eligible" src={disabledImage}>
                {/if}
                <div class="nav-text-block">
                    Complete Medical Questions
                </div>
            </a>
        </div>
    {/if}

    <div class="nav-dot">. .</div>

    {#if navState.identificationUploadCompleted}
    <div>
        <a href="*" class="nav-block {navState.disableAll === true ? 'disabled-anchor' : ''}" on:click|preventDefault={() => navigationRequested('identification')}>
            <img class="completed-image" src={completedImage} alt="Identification Upload Completed">
            <div class="nav-text-block">
                Upload Identification
            </div>
        </a>
    </div>
    {:else}
    <div>
        <a href="*" class="{(navState.identificationUploadEligible && !navState.disableAll) ? 'nav-block' : 'nav-block disabled-anchor'}" on:click|preventDefault={() => navigationRequested('identification')}>
            {#if navState.identificationUploadEligible}
                <img class="nav-image" alt="Identification Upload" src={eligibleImage}>
            {:else}
                <img class="nav-image" alt="Identification Upload Not Eligible" src={disabledImage}>
            {/if}
            <div class="nav-text-block">
                Upload Identification
            </div>
        </a>
    </div>
    {/if}

    <div class="nav-dot">. .</div>

    {#if navState.readyToBeContactedComplete}
    <div>
        <a href="*" class="nav-block {navState.disableAll === true ? 'disabled-anchor' : ''}">
            <img class="completed-image" src={completedImage} alt="Ready To Be Contacted Completed">
            <div class="nav-text-block">
                I'm Ready To Be Contacted
            </div>
        </a>
    </div>
    {:else}
    <div>
        <a href="*" class="{(navState.readyToBeContactedEligible && !navState.disableAll) ? 'nav-block' : 'nav-block disabled-anchor'}" on:click|preventDefault={() => navigationRequested('readyToBeContacted')}>
            {#if navState.readyToBeContactedEligible}
                <img class="nav-image" alt="Ready To Be Contacted" src={eligibleImage}>
            {:else}
                <img class="nav-image" alt="Ready To Be Contacted Not Eligible" src={disabledImage}>
            {/if}
            <div class="nav-text-block">
                I'm Ready To Be Contacted
            </div>
        </a>
    </div>
    {/if}
</div>

<style lang="scss">
    @use "../../component_scss_library/fonts" as fonts;

    a {
      text-decoration: none;
      color: #000;
      :visited {
        color: #000;
      }
    }

    .top-level-navigation {
      display: flex;
      flex-direction: row;
      justify-items: auto;
      justify-content: center;
      width: 100%;
      padding: 20px;
      @include fonts.primary();

      @media screen and (max-width: 768px) {
        flex-direction: column;
        padding: 10px;
      }
    }

    .nav-image {
      height: 96px;
      width: 96px;

      @media screen and (max-width: 992px)  {
        height: 64px;
        width: 64px;
      }

      @media screen and (max-width: 768px)  {
        height: 96px;
        width: 96px;
      }
    }
    .nav-image-disabled {
      height: 96px;
      width: 96px;
      background-color: #8f8f8f;
      border: 2px solid #4c12a1;

      @media screen and (max-width: 992px)  {
        height: 64px;
        width: 64px;
      }
      @media screen and (max-width: 768px)  {
        height: 96px;
        width: 96px;
      }
    }
    .completed-image {
      height: 96px;
      width: 96px;

      @media screen and (max-width: 992px)  {
        height: 64px;
        width: 64px;
      }
      @media screen and (max-width: 768px)  {
        height: 96px;
        width: 96px;
      }
    }
    .nav-block {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 10px;
      font-size: 13px;
      font-weight: bold;
    }
    .nav-text-block {
      width: 120px;
      margin-top: 8px;
      word-wrap: normal;
      text-align: center;
      font-size: 16px;

      @media screen and (max-width: 992px) {
        font-size: 12px;
      }
    }
    .disabled-anchor {
      pointer-events: none;
    }
    .nav-dot {
      font-size: 60px;
      margin-top: -12px;
      align-content: center;
      color: #8f8f8f;
      min-width: 48px;

      @media screen and (max-width: 992px)  {
        font-size: 40px;
        min-width: 40px;
      }
      @media screen and (max-width: 768px) {
        visibility: hidden;
      }
    }
</style>
